import { MatDialog } from '@angular/material';
import { Injectable, Inject } from '@angular/core';
import { Image, Partner } from '../../../models/index';
import { ShowItemDetailsModalBaseComponent } from './show-item-details-modal-base/show-item-details-modal-base.component';
import {
  ShowTestimonialsContentModalBaseComponent
} from './show-testimonials-content-modal-base/show-testimonials-content-modal-base.component';
import { ShowCameraTutorialModalBaseComponent } from './show-camera-tutorial-modal-base/show-camera-tutorial-modal-base.component';
import { ShowContactFormModalBaseComponent } from './show-contact-form-modal-base/show-contact-form-modal-base.component';
import { DOCUMENT } from '@angular/platform-browser';

@Injectable()
export class OpenModalService {

  constructor(
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: any
  ) { }

  public showDetailsModal(title: string, job: string, description: string, image: Image): void {
    this.document.body.classList.add('no-scroll');

    this.dialog.open(
      ShowItemDetailsModalBaseComponent,
      {
        data: {
          title: title,
          job: job,
          description: description,
          image: image
        }
      }
    );
  }

  public showPartnersContent(partner: Partner): void {
    this.document.body.classList.add('no-scroll');

    this.dialog.open(
      ShowItemDetailsModalBaseComponent,
      {
        data: {
          title: partner.name,
          description: partner.description,
          image: partner.image,
          link: partner.link
        }
      }
    );
  }

  public showTestimonialsContent(name: string, content: string): any {
    this.document.body.classList.add('no-scroll');

    return this.dialog.open(
      ShowTestimonialsContentModalBaseComponent,
      {
        data: {
          name: name,
          content: content
        }
      }
    );
  }

  public showCameraTutorialModal(): void {
    this.document.body.classList.add('no-scroll');

    this.dialog.open(
      ShowCameraTutorialModalBaseComponent,
      {
        width: '100vw'
      }
    );
  }

  public showContactFormModal(): void {
    this.document.body.classList.add('no-scroll');

    this.dialog.open(
      ShowContactFormModalBaseComponent,
      {
        height: '100vh',
        width: '100vw'
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/open-modal.service.ts